import { supabase } from '../supabaseClient';

/**
 * 팀장 탭 등 클래스 공통으로 보여줄 때 쓰는 공유 grade_id.
 * 해당 워크스페이스 grades.id 중 사전순 최소값.
 */
export async function getWorkspaceShareGradeId(workspaceId: string): Promise<string | null> {
  const ws = workspaceId.trim();
  if (!ws) return null;
  const { data, error } = await supabase
    .from('grades')
    .select('id')
    .eq('workspace_id', ws)
    .order('id', { ascending: true })
    .limit(1)
    .maybeSingle();
  if (error) throw new Error(error.message);
  const id = typeof data?.id === 'string' ? data.id.trim() : '';
  return id || null;
}
